<template>
	<div class="limit">
		<!-- 顶部banner -->
		<div class="nav" style="border: none;">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<div>限时抢购</div>
			<div></div>
		</div>
		<div class="tipsA">
			<div @click="changeCart(-1, -1)" :class="{'active': cartid == -1}">
				<span>全部</span>
				<img src="../../assets/whole.png" alt="">
			</div>
			<div v-for="(item,index) in list" @click="changeCart(index,item.id)" :class="{'active': cartid == index}">
				<span>{{item.title}}</span>
				<img :src="item.image | handleUrl" alt="">
			</div>
		</div>
		<!-- 最近秒杀信息 -->
		<van-swipe class="limit-msg" vertical :show-indicators="false" :autoplay="4500">
			<van-swipe-item v-for="item in noticeIndex">
				<img :src="item.src" alt="">
				<div>{{item.name}}</div>
				<div>{{item.msg}}</div>
			</van-swipe-item>
		</van-swipe>
		<!-- 即将售罄 -->
		<div class="limit-list" v-if="product.length != 0">
			<div class="limit-list-header">
				<img src="../../assets/xsg.png" alt="">
				<div>即将售罄</div>
			</div>
			<div class="limit-list-main" v-for="item in product" @click='hreftwo(item.id)'>
				<img :src="item.image | handleUrl" alt="">
				<div class="limit-list-main-right">
					<div>{{item.title}}</div>
					<div>
						距下架
						<count-down class="time" :startTime="item.current_time" :endTime="item.limit_end_limit_time | toNumber" :dayTxt="'天'"
						 :hourTxt="'天'" :minutesTxt="'分'" :secondsTxt="''">
						</count-down>
					</div>
					<ProGress :percentage="item.hundred" status="exeption" :textInside=true :showText=true :strokeWith="0.4" />
					<div>
						<div class="list-vip">
							<div>
								<span style="font-size:0.75rem">¥</span><span>{{item.price}}</span>
							</div>
							<div class="tags">vip专享¥{{item.vip_price}}</div>
						</div>
						<button color="#fe3f2c" round>去抢购</button>
					</div>
				</div>
			</div>
		</div>
		<!-- 限时抢购 -->
		<div class="limit-list" ref="wrapper">

			<div class="limit-list-header">
				<img src="../../assets/xsg.png" alt="">
				<div>限时抢购</div>
			</div>
			<!-- :to="{path: '/bidDetail', query: {id:item.id,cart_id:this.cart_id}}" -->
			<div class="limit-list-main" v-for="item in product2" @click='hreftwo(item.id)'>
				<img :src="item.image | handleUrl" alt="">
				<div class="limit-list-main-right">
					<div>{{item.title}}</div>
					<div>
						距下架<count-down class="time" :startTime="item.current_time" :endTime="item.limit_end_limit_time | toNumber"
						 :dayTxt="'天'" :hourTxt="'时'" :minutesTxt="'分'" :secondsTxt="'秒'"></count-down>
					</div>
					<ProGress :percentage="item.hundred" status="exeption" :textInside=true :showText=true :strokeWith="0.4" />
					<div>
						<div class="list-vip">
							<div>
								<span style="font-size:0.75rem">¥</span><span>{{item.price}}</span>
							</div>
							<div class="tags">vip享{{item.vip_price}}</div>
						</div>
						<button color="#fe3f2c" round>去抢购</button>
					</div>
				</div>
			</div>
		</div>
		<div class="loding" v-if="isLoding">
			加载中...
		</div>
		<div class="loding" v-if="isNone">
			我是有底线的~
		</div>
	</div>
</template>

<script>
	import ProGress from '@/components/progress'
	import {
		debounce
	} from '@/assets/js/common'
	import CountDown from 'vue2-countdown'

	export default {
		name: 'limit',
		data() {
			return {
				list: [],
				cartid: -1,
				product: [],
				product2: [],
				cart_id: -1,
				group: 1, //当前页码
				endScoll: false, //判断是否到达底部
				isLoding: true, //判断是否请求中
				isNone: false, //判断是否加载完毕
				notice: [{
					id: 1,
					name: '会展的故事',
					msg: '3分钟前抢到了华都洽谈桌',
					src: require('../../assets/user.png')
				}, {
					id: 2,
					name: '飞飞fly',
					msg: '23分钟前抢到了主管办公桌',
					src: require('../../assets/feifei1.jpg')
				}, {
					id: 3,
					name: '赵公子',
					msg: '9秒前抢到了迪欧-大班台',
					src: require('../../assets/feifei2.jpg')
				}, {
					id: 4,
					name: '秋天的风',
					msg: '13分钟前抢到了三人位办公沙发',
					src: require('../../assets/feifei3.jpg')
				}, {
					id: 5,
					name: '老船',
					msg: '3秒前抢到了迪欧-文件柜',
					src: require('../../assets/feifei4.jpg')
				}, {
					id: 6,
					name: 'Maybe',
					msg: '26秒前抢到了迪欧-办公桌',
					src: require('../../assets/feifei5.jpg')
				}, {
					id: 7,
					name: '名字',
					msg: '20分钟前抢到了加脚踏办公椅',
					src: require('../../assets/feifei6.jpg')
				}, {
					id: 8,
					name: '迷',
					msg: '10秒前抢到了透网办公椅',
					src: require('../../assets/feifei7.jpg')
				}, {
					id: 9,
					name: '小唐',
					msg: '7分钟前抢到了扶手培训椅',
					src: require('../../assets/feifei8.jpg')
				}],
				noticeIndex: []
			}
		},
		components: {
			ProGress,
			CountDown
		},

		created() {
			for (let i = 0; i < 4; i++) {
				let num = Math.floor(Math.random() * (8 - 0)) + 0;
				let res = this.noticeIndex.some(item => {
					if (item.id === this.notice[num].id) {
						return true
					}
				})
				if (!res && this.noticeIndex.length < 3) {
					this.noticeIndex.push(this.notice[num])
				}
			}
			//分类列表
			this.$axios.post(baseUrl + '/mobile/Limit_Goods/limitGoodsCategory').then((res) => {
				if (res.data.code == 2) {
					this.list = res.data.data.category;
				}
			}).catch((err) => {
				console.log(err);
			});
			setTimeout(() => {
				this.cart_id = -1;
				this.sellOut();
				this.getGoods();
			}, 500);

		},
		mounted() {
			window.onscroll = () => {
				if (this.scrollCheck()) {
					this.getGoods();
				}
			}
		},
		methods: {
			hreftwo(id) {
				this.$router.push({
					path: '/limitDetail',
					query: {
						id: id,
						cart_id: this.cart_id
					}
				})
			},
			//切换分类
			changeCart(index, id) {
				this.isLoding = true;
				this.cart_id = id;
				this.group = 1;
				this.product = [];
				this.product2 = [];
				this.cartid = index;
				this.sellOut();
				this.getGoods();
			},
			//获取商品列表
			getGoods: debounce(function() {
				//限时抢购
				this.$axios.post(baseUrl + '/mobile/Limit_Goods/limitGoods', {
					page: this.group,
					limit: 10,
					cat_id: this.cart_id
				}).then((res) => {
					if (res.data.code == 2) {
						console.log(res.data.data)
						for (let i in res.data.data) {
							this.product2.push(res.data.data[i])
						}
						this.group++;
						this.isLoding = false;
					} else {
						this.isNone = true;
					}
				}).catch((err) => {
					console.log(err);
				});
			}, 500),
			//获取即将售罄
			sellOut() {
				//即将售罄
				this.$axios.post(baseUrl + '/mobile/Limit_Goods/limitHotGoods', {
					cat_id: this.cart_id
				}).then((res) => {
					if (res.data.code == 2) {
						for (let i in res.data.data) {
							this.product.push(res.data.data[i])
						}
					}
				}).catch((err) => {
					console.log(err);
				});
			},
			//检查滚动底部
			scrollCheck() {
				// 变量scrollTop是滚动条滚动时，距离顶部的距离
				var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				// //变量windowHeight是可视区的高度
				var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
				// //变量scrollHeight是滚动条的总高度
				var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
				//滚动条到底部的条件
				if (scrollTop + windowHeight == scrollHeight) {
					return true;
				}
				return false;
			}
		},
		filters: {
			'toNumber': function(value) {
				return parseInt(value);
			}
		},
	}
</script>

<style scoped>
	@import 'limit.css';

	.limit .limit-list /deep/ .time p {
		margin: 0 !important;
	}

	.limit .limit-list /deep/ .time span {
		display: inline-block;
		background: #ffffff;
		color: red;
		border-radius: 0.2rem;
		display: inline-block;
		font-size: 0.9rem;
		font-weight: bold;
		padding: 0.1rem;
	}

	.limit .limit-list /deep/ .time i {
		color: #000;
		font-style: normal;
	}

	.limit .limit-list /deep/ .time span:nth-child(1) {
		background: none;
	}

	.limit .limit-list /deep/ .time span:nth-child(1) span {
		background: #ffffff;
		font-size: 0.9rem;

	}

	.limit .limit-list[data-v-6420b31b] .time span:nth-child(1) span {
		background: #ffffff !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/home/limit.vue